import { useQuery } from '@tanstack/react-query';

import { createDashboard } from '../../Repositories';

const dashboardReq = createDashboard();

/**
 * this function(query) is to get dashboard details
 * @function useDashboardGetQuery
 * @param {Object} reqParams params pass along with the api call
 * @param {Object} options to be passed as query handling
 * @returns api response
 */
export function useDashboardGetQuery(reqParams, options) {
  return useQuery(
    ['dashboardGetQuery', reqParams],
    () => dashboardReq.getDashboardDetails(reqParams),
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      ...options,
    }
  );
}
